export default __webpack_public_path__ + "static/media/view1.217d7110.jpg";